"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.onSync = void 0;

var _staticReqMapping = _interopRequireDefault(require("smarket-pithy/lib/utils/staticReqMapping"));

var _request = _interopRequireDefault(require("smarket-pithy/lib/request"));

var _config = _interopRequireDefault(require("smarket-pithy/lib/config"));

var getStatic = function getStatic(path, reqConfig) {
  return _request.default.getJson(path, reqConfig);
};

var onSync = function onSync(apiPath) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var apiConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var staticUrl = _staticReqMapping.default.getStaticUrl(apiPath, params);

  var config = (0, _config.default)();

  if (config.isStatic && staticUrl) {
    if (params.isProject) {
      return getStatic(staticUrl, {
        baseURL: (0, _config.default)('api.gateway.projectJsonUrl')
      });
    } else {
      return getStatic(staticUrl, {
        baseURL: (0, _config.default)('api.gateway.jsonUrl')
      });
    }
  }

  return _request.default.postJson(apiPath, params, apiConfig);
};

exports.onSync = onSync;
var _default = {
  onSync: onSync
};
exports.default = _default;